'use client';

import clsx from 'clsx';
import { sportMenuStyle } from './sports-menu.style';
import { useContext, ContextType, MutableRefObject } from 'react';
import dynamic from 'next/dynamic'
import 'react-horizontal-scrolling-menu/dist/styles.css';
import { VisibilityContext } from 'react-horizontal-scrolling-menu';
type scrollVisibilityApiType = ContextType<typeof VisibilityContext>;

const ScrollMenu = dynamic(() => import('react-horizontal-scrolling-menu').then(mod => mod.ScrollMenu), { ssr: false });

const LeftArrow = () => {
	const { isFirstItemVisible } = useContext(VisibilityContext);
	return (
		<div
			className={clsx('sports-menu__mask', sportMenuStyle.sportsMenu_mask, sportMenuStyle.sportsMenu_maskLeft)}
			data-disabled={isFirstItemVisible ?? true}
		/>
	);
}

const RightArrow = () => {
	const { isLastItemVisible } = useContext(VisibilityContext);
	return (
		<div
			className={clsx('sports-menu__mask', sportMenuStyle.sportsMenu_mask, sportMenuStyle.sportsMenu_maskRight)}
			data-disabled={isLastItemVisible}
		/>
	);
}


const MaskRightArrow = () => {
	const { isLastItemVisible } = useContext(VisibilityContext);
	return (
		<div
			className="tab__mask tab__mask--right"
			data-disabled={isLastItemVisible}
		/>
	);
};
interface ScrollMenuProps {
    enableLeftArrow: boolean;
	enableMaskRightArrow?: boolean;
    apiRef: MutableRefObject<scrollVisibilityApiType>;
    children: any;
	WrapperClassName?: string;
	ContainerClassName?: string
}
export const ScrollingWrapper = ({ 
	enableLeftArrow, 
	enableMaskRightArrow,
	apiRef, 
	children,
	WrapperClassName,
	ContainerClassName
}: ScrollMenuProps) => {
	return (
		<ScrollMenu
			LeftArrow={enableLeftArrow ? LeftArrow : null}
			RightArrow={enableMaskRightArrow ? MaskRightArrow  : RightArrow}
			apiRef={apiRef}
			wrapperClassName={WrapperClassName ?? '' }
			scrollContainerClassName={ContainerClassName ?? ''}
		>
			{children}
		</ScrollMenu>
	);
}